/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */

import type { ApiError, ApiSuccess } from "@virgodev/bazaar/functions/api";
import api from "@virgodev/bazaar/functions/api";

export interface ApiAdapterOptions {
  responseKey?: string;
}

export class ApiAdapter<T> {
  endpoint: string;
  filters: { [index: string]: string };
  options?: ApiAdapterOptions;

  constructor(endpoint: string, options?: ApiAdapterOptions) {
    this.options = options;
    this.endpoint = endpoint;
    this.filters = {};
  }

  async get(id: string | number): Promise<T> {
    let response = await api({ url: `${this.endpoint}/${id}/` });
    if (response.ok) {
      return response.body;
    }
    throw new Error((response as ApiError).error);
  }

  async list(
    filters: { [key: string]: string },
    allPages = false,
  ): Promise<T[]> {
    let retval: T[] = [];
    const myfilters = {};
    for (const name in this.filters) {
      myfilters[name] = this.filters[name];
    }
    for (const name in filters) {
      myfilters[name] = filters[name];
    }
    let response = await api({
      url: `${this.endpoint}/`,
      method: "GET",
      params: myfilters,
    });

    if (response.ok) {
      let body = response.body;
      if (this.options?.responseKey) {
        body = body[this.options.responseKey];
      }
      if (!body.results) {
        retval = retval.concat(body);
      } else {
        retval = retval.concat(body.results);
      }
      while (allPages && response.body.next) {
        response = await api({ url: response.body.next });
        if (response.ok) {
          retval = retval.concat(response.body.results);
        } else {
          throw new Error((response as ApiSuccess).body.error);
        }
      }
      return retval;
    }
    throw new Error((response as ApiError).error);
  }

  async delete(id: number): Promise<void> {
    let response = await api({
      url: `${this.endpoint}/${id}/`,
      method: "DELETE",
    });

    if (response.ok) {
      return response.body;
    }
    throw new Error("Bad response");
  }

  async update(id: number, object: T): Promise<any> {
    let response: ApiError | ApiSuccess | null = null;
    if (!id) {
      response = await api({
        url: `${this.endpoint}/`,
        method: "POST",
        json: object,
      });
    } else {
      response = await api({
        url: `${this.endpoint}/${id}/`,
        method: "PATCH",
        json: object,
      });
    }
    return response.body;
  }
}
